import 'reflect-metadata'
import { AccessControlPolicy } from '@repo/alt/Services'
import { injectable, injectFromBase, inject } from 'inversify'

import { AuthService } from '#Auth/services'

@injectable()
@injectFromBase({ extendConstructorArguments: true })
export class AuthAccessControlPolicy extends AccessControlPolicy {
  static override namespace = 'auth'

  constructor(
    @inject(AuthService) readonly $service: AuthService,
  ) {
    super()
  }

  get isAuthorized() {
    const token = this.$service.getToken()

    return Boolean(token)
  }
}
